import * as m from "#/paraglide/messages";
import {
  createBackendFailureMessageResolver,
  readBackendFailure,
} from "#/shared/lib/backend-api";

import {
  getKnowledgeOverviewOperation,
  type GetKnowledgeOverviewOperation,
} from "../api/get-knowledge-overview";
import {
  getKnowledgeProductsOperation,
  type GetKnowledgeProductsOperation,
} from "../api/get-knowledge-products";
import {
  getKnowledgeQuestionsOperation,
  type GetKnowledgeQuestionsOperation,
} from "../api/get-knowledge-questions";

type KnowledgeOperation =
  | GetKnowledgeOverviewOperation
  | GetKnowledgeProductsOperation
  | GetKnowledgeQuestionsOperation;

const resolveFailureMessage =
  createBackendFailureMessageResolver<KnowledgeOperation>({
    forbidden: () => m.knowledge_failure_forbidden(),
    network: () => m.knowledge_failure_network(),
    rejected: () => m.knowledge_failure_rejected(),
    schema: () => m.knowledge_failure_schema(),
    unexpected: () => m.knowledge_failure_unexpected(),
  });

/**
 * 把读 Knowledge 时抛出的任意错误翻成一句可展示文案。
 * 三个读操作共用一组文案：商家看到的都是「这一屏没取到」，不必分辨是哪个接口。
 * 不是本 feature 的失败时返回 null，界面据此保持安静。
 */
export function readKnowledgeFailureMessage(error: unknown): string | null {
  return resolveFailureMessage(
    readBackendFailure(error, [
      getKnowledgeOverviewOperation,
      getKnowledgeProductsOperation,
      getKnowledgeQuestionsOperation,
    ]),
  );
}
